var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-phone-number-input',_vm._g(_vm._b({key:`phone-input-${_vm.dynamicAttrs.base}`,staticClass:"mb-1",attrs:{"name":"phone","color":_vm.color,"border-radius":0,"no-country-selector":_vm.noCountrySelector,"no-flags":true,"no-example":true,"show-code-on-list":true,"error":_vm.error,"translations":{
		countrySelectorLabel: '',
		countrySelectorError: _vm.$t('country-selector-error'),
		phoneNumberLabel: _vm.$t('phone-number-label'),
		example: _vm.$t('example'),
	},"disabled":_vm.disabled,"autocomplete":"tel"},on:{"input":_vm.inputHandler},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}},'vue-phone-number-input',{..._vm.$attrs, ..._vm.dynamicAttrs},false),_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }